module.exports = __webpack_public_path__ + "img/frame2.d6d0692a.jpg";